module.exports = __webpack_public_path__ + "static/img/img_ab_zz_c.caa2cf74.png";